var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMajorRecruit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_424_1296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_1296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 21.5L46.5 28.5L32 36L17.5 28.5L32 21.5Z",
    fill: "#C6E7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6599 19.9318C33.8285 19.5379 32.9199 19.3336 31.9999 19.3336C31.0799 19.3336 30.1713 19.5379 29.3399 19.9318L13.9056 27.2437C13.6215 27.3777 13.3837 27.5932 13.2224 27.8627C13.0612 28.1322 12.9837 28.4437 12.9999 28.7573V38.3397C12.9999 38.7596 13.1667 39.1623 13.4637 39.4593C13.7606 39.7562 14.1633 39.923 14.5832 39.923C15.0032 39.923 15.4059 39.7562 15.7028 39.4593C15.9998 39.1623 16.1666 38.7596 16.1666 38.3397V31.2273L19.3332 32.798V41.5063C19.3333 41.7146 19.3744 41.9209 19.4543 42.1132C19.5342 42.3056 19.6512 42.4803 19.7987 42.6273L19.8779 42.7033L20.0679 42.8775C21.0604 43.7619 22.1332 44.5518 23.2726 45.2367C25.3879 46.5097 28.4437 47.8397 31.9999 47.8397C35.5561 47.8397 38.6119 46.5097 40.7304 45.2367C41.8697 44.5518 42.9426 43.7619 43.9351 42.8775L44.1251 42.7033L44.1979 42.6273H44.2042C44.3516 42.4796 44.4682 42.3043 44.5476 42.1114C44.6269 41.9185 44.6674 41.7118 44.6666 41.5032V32.7948L50.1196 30.0905C50.3861 29.9585 50.6101 29.7541 50.7659 29.5006C50.9216 29.2472 51.0028 28.955 51.0002 28.6576C50.9975 28.3601 50.9111 28.0694 50.7509 27.8188C50.5907 27.5682 50.3631 27.3678 50.0942 27.2405L34.6599 19.9287V19.9318ZM34.7612 37.7127L41.4999 34.3687V40.8033C40.7487 41.4405 39.947 42.0155 39.1027 42.5228C37.2661 43.6248 34.7771 44.673 31.9999 44.673C29.2227 44.673 26.7369 43.628 24.8971 42.5228C24.0528 42.0155 23.2511 41.4405 22.4999 40.8033V34.3687L29.2386 37.7127C30.9802 38.574 33.0196 38.574 34.7612 37.7127ZM33.3046 22.7945L45.7876 28.7067L33.3521 34.8753C32.9317 35.0835 32.469 35.1919 31.9999 35.1919C31.5308 35.1919 31.0681 35.0835 30.6477 34.8753L18.2122 28.7067L30.6952 22.7945C31.103 22.6012 31.5487 22.501 31.9999 22.501C32.4512 22.501 32.8968 22.6012 33.3046 22.7945ZM44.1979 42.6305L44.1947 42.6337L44.1979 42.6305Z",
    fill: "#303644"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_424_1296",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.905882 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_424_1296"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_1296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajorRecruit);
export default __webpack_public_path__ + "static/media/major_recruit.898355cca81cb7c6d9cea10be994af95.svg";
export { ForwardRef as ReactComponent };